import { PublicMain } from './PublicMain';

export default PublicMain;
